<div class="tab-group">
  <div #tabList [class.scrollable]="tabListScroll().length > 0" role="tablist">
    <div class="navigation-button back" [class.visible]="tabListScroll().includes('left')">
      <opac-button tabindex="-1" (click)="moveScroll(-1)">
        <opac-icon icon="navigate_back" slot="only-icon"></opac-icon>
      </opac-button>
    </div>

    <div #tabContainer class="container">
      <ng-content select="opac-tab"></ng-content>
      <div class="tab-indicator" [style.transform]="'translateX(' + indicatorPosition() + 'px)'"></div>
    </div>

    <div class="navigation-button next" [class.visible]="tabListScroll().includes('right')">
      <opac-button tabindex="-1" (click)="moveScroll(1)">
        <opac-icon icon="navigate_next" slot="only-icon"></opac-icon>
      </opac-button>
    </div>
  </div>

  <ng-content select="opac-tab-panel"></ng-content>
</div>
